import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from '../Dashboad.service';

@Component({
  selector: 'app-team-progress',
  templateUrl: './team-progress.component.html',
  styleUrls: ['./team-progress.component.css']
})
export class TeamProgressComponent implements OnInit {

  userId:number;

  currentDate = new Date();
  teamYear = this.currentDate.getFullYear();
  currentMonth = this.currentDate.getMonth() + 1;
  teamQuarterNo = Math.ceil(this.currentMonth / 3);

  labels2= ['Jan', 'Feb', 'Mar'];
  element: any;

  teamTotalPrograms = []
  teamCompletedCourses = [];
  teamTotalCourses = [];
  teamInprogressCourses = [];
  teamNotStartedCourses = [];

  pieChart = false;

  lineChartDataItems2: any = [];
  lineChartData2 = {
    labels: this.labels2,
    datasets: [
      {
        label: 'Courses',
        fill: true,
        backgroundColor: 'rgba(33, 150, 243, 0.2)',
        borderColor: '#1E88E5',
        data: this.lineChartDataItems2
      }
    ],
  };

  yearData = [2024,2025,2026,2027];
  quarterData = [
    {
      id: 1,
      name: 'Q1 (Jan-Mar)'
    },
    {
      id: 2,
      name: 'Q2 (Apr-Jun)'
    },
    {
      id: 3,
      name: 'Q3 (Jul-Sep)'
    },
    {
      id: 4,
      name: 'Q4 (Oct-Dec)'
    }
  ];
  pieChartData: { labels: string[]; datasets: { data: any[]; backgroundColor: string[]; }[]; };
  pieChartOptions: { plugins: { legend: { position: string; align: string; labels: { usePointStyle: boolean; color: string; }; }; }; };
  pieDataNotFound: boolean;
  
  constructor(private DashboardService : DashboardService){}
  ngOnInit(): void {
    this.userId = parseInt(localStorage.getItem('EmpCareerUserID'));
    this.onTeamQuarterChange();
  }
  onTeamQuarterChange() {
    this.teamQuarterNo = +this.teamQuarterNo;
    if(this.teamQuarterNo == 1) {
      this.labels2 = ['Jan', 'Feb', 'Mar'];
    } else if(this.teamQuarterNo == 2) {
      this.labels2 = ['Apr', 'May', 'Jun'];
    } else if(this.teamQuarterNo == 3) {
      this.labels2 = ['Jul', 'Aug', 'Sep'];
    } else if(this.teamQuarterNo == 4) {
      this.labels2 = ['Oct', 'Nov', 'Dec'];
    }
    this.getTeamProgressCounts(this.teamQuarterNo, this.teamYear);
    this.getTeamProgressForLineChart(this.teamQuarterNo, this.teamYear);
  }

  onTeamYearChange() {
    this.teamYear = +this.teamYear;
    this.getTeamProgressCounts(this.teamQuarterNo, this.teamYear);
    this.getTeamProgressForLineChart(this.teamQuarterNo, this.teamYear);
  }

  showTeamLineChart() {
    this.pieChart = false;
  }

  showTeamPieChart() {
    this.pieChart = true;
  }

  getTeamProgressCounts(quarter, year) {
    var model = {
      userId: this.userId,
      year: year,
      quarterNo: quarter
    }
    this.teamCompletedCourses = [];
    this.teamInprogressCourses = [];
    this.teamNotStartedCourses = [];
    this.teamTotalCourses = [];
    this.pieChartData = {      
      datasets: [
        {
          data: [0,0,0],
          backgroundColor: ['#7DBE7D', '#ffce61', '#ff6e6e'],
        }
      ],
      labels: ['Completed', 'In Progress', 'Not Started'],
    };
    this.pieChartOptions = {
      plugins: {
        legend: {
          position: 'right',
          align: 'bottom',
          labels: {
            usePointStyle: false,
            color: 'Black'
          }
        }
      }
    };
    this.pieDataNotFound = true;
    this.DashboardService.getTeamProgressCounts(model).subscribe((res:any) => {
      if(res) {
        this.teamCompletedCourses.push(res[0].coursescompleted);
        this.teamInprogressCourses.push(res[0].coursesInprogress);
        this.teamNotStartedCourses.push(res[0].coursesNotStarted);
        this.teamTotalCourses.push(res[0].totalCourses);
      }
      this.pieDataNotFound = false;
      this.pieChartData = {        
        datasets: [
          {
            data: [this.teamCompletedCourses[0], this.teamInprogressCourses[0], this.teamNotStartedCourses[0]],
            backgroundColor: ['#7DBE7D', '#ffce61', '#ff6e6e'],
          }
        ],
        labels: ['Completed', 'In Progress', 'Not Started'],
      };
      // this.chart3?.refresh();
    }, error => {
    })
  }

  getTeamProgressForLineChart(quarter, year) {
    var model = {
      userId: this.userId,
      year: year,
      quarterNo: quarter
    }
    this.lineChartDataItems2 = [];
    this.DashboardService.getTeamProgressForLineChart(model).subscribe((res:any) => {
      if(res) {
        var data = Array.from(res);
        data.forEach(x => {
          this.element = x;
          if(quarter == 1) {
            this.element.month == 1 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 2 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 3 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
          } else if (quarter == 2) {
            this.element.month == 4 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 5 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 6 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
          } else if (quarter == 3) {
            this.element.month == 7 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 8 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 9 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
          } else {
            this.element.month == 10 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 11 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
            this.element.month == 12 ? this.lineChartDataItems2.push(this.element.totalCourses) : this.lineChartDataItems2.push(0);
          }
        });
      }
      this.lineChartData2 = {
        labels: this.labels2,
        datasets: [
          {
            label: 'Courses',
            fill: true,
            backgroundColor: 'rgba(33, 150, 243, 0.2)',
            borderColor: '#1E88E5',
            data: this.lineChartDataItems2
          }
        ],
      };
      // this.chart4?.refresh();
    }, error => {
    });
    // this.chart4?.refresh();
    // this.chart4.reinit();
  }

}
